import React, { useState } from 'react';
import Navbar from '../Navbar/Navbar';
import api from '../Axios/axios';
import './AddCompany.scss';

const initialFormData = {
  employeeName: '',
  employeeSurname: '',
  employeeEmail: '',
  employeePassword: '',
  hasTowerCrane: false,
  rentTowerCrane: false,
  name: '',
  email: '',
  address: '',
  taxNo: '',
  authorizedPerson1: '',
  phoneNumber1: '',
  authorizedPerson2: '',
  phoneNumber2: '',
  bankReceiver1: '',
  bankName1: '',
  iban1: '',
  bankReceiver2: '',
  bankName2: '',
  iban2: '',
};

const AddCompany = () => {
  const [formData, setFormData] = useState(initialFormData);
  const [passwordError, setPasswordError] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const validatePassword = (password) => {
    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>]).{8,}$/;
    return passwordRegex.test(password);
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (name === 'employeePassword') {
      if (!validatePassword(value)) {
        setPasswordError(
          'Şifre en az bir küçük harf, bir büyük harf, bir rakam ve bir özel karakter içermeli; en az 8 karakter olmalıdır.'
        );
      } else {
        setPasswordError('');
      }
    }

    if ((name === 'phoneNumber1' || name === 'phoneNumber2') && !/^\d*$/.test(value)) {
      return;
    }

    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting) {
      return;
    }

    if (!validatePassword(formData.employeePassword)) {
      setErrorMessage(
        'Şifre geçersiz. En az bir küçük harf, bir büyük harf, bir rakam ve bir özel karakter içermelidir.'
      );
      return;
    }

    try {
      setIsSubmitting(true);
      setErrorMessage('');
      setSuccessMessage('');
      const payload = {
        ...formData,
        isRentingMachineCompany: formData.hasTowerCrane,
      };
      const response = await api.post('/Company', payload);
      console.log('Şirket başarıyla eklendi:', response.data);
      setSuccessMessage('Şirket ve giriş hesabı başarıyla oluşturuldu.');
      setFormData(initialFormData);
    } catch (error) {
      console.error('Şirket eklenemedi:', error.response ? error.response.data : error);
      const rawResponse =
        typeof error?.response?.data === 'string'
          ? error.response.data
          : error?.response?.data
            ? JSON.stringify(error.response.data)
            : '';
      const apiMessage =
        error?.response?.data?.messages?.join(' ') ||
        error?.response?.data?.message ||
        error?.response?.data?.title ||
        (rawResponse
          ? `Şirket eklenemedi. Status: ${error?.response?.status || 'Bilinmiyor'}. ${rawResponse}`
          : 'Şirket eklenemedi. Lütfen bilgileri kontrol edin.');
      setErrorMessage(apiMessage);
      setSuccessMessage('');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="add-company-page">
      <Navbar />
      <div className="form-container">
        <h2>Şirket Ekle</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-row">
            <div className="form-group">
              <input
                type="text"
                name="employeeName"
                value={formData.employeeName}
                onChange={handleInputChange}
                placeholder="Çalışan Adı"
                required
              />
            </div>
            <div className="form-group">
              <input
                type="text"
                name="employeeSurname"
                value={formData.employeeSurname}
                onChange={handleInputChange}
                placeholder="Çalışan Soyadı"
                required
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <input
                type="email"
                name="employeeEmail"
                value={formData.employeeEmail}
                onChange={handleInputChange}
                placeholder="Çalışan E-posta"
                required
              />
            </div>
            <div className="form-group password-group">
              <input
                type={showPassword ? 'text' : 'password'}
                name="employeePassword"
                value={formData.employeePassword}
                onChange={handleInputChange}
                placeholder="Çalışan Şifresi"
                required
              />
              <i
                className={`eye-icon ${showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'}`}
                onClick={togglePasswordVisibility}
              />
              {passwordError && <p className="error-message">{passwordError}</p>}
            </div>
          </div>

          <div className="form-row checkbox-group">
            <div className="form-group">
              <label>Kule Vinç Var mı?</label>
              <input
                type="checkbox"
                name="hasTowerCrane"
                checked={formData.hasTowerCrane}
                onChange={handleInputChange}
              />
            </div>
            <div className="form-group">
              <label>Kule Vinci Kiralıyor mu?</label>
              <input
                type="checkbox"
                name="rentTowerCrane"
                checked={formData.rentTowerCrane}
                onChange={handleInputChange}
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                placeholder="Şirket Adı"
                required
              />
            </div>
            <div className="form-group">
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                placeholder="Şirket E-posta"
                required
              />
            </div>
            <div className="form-group">
              <input
                type="text"
                name="address"
                value={formData.address}
                onChange={handleInputChange}
                placeholder="Şirket Adresi"
                required
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <input
                type="text"
                name="taxNo"
                value={formData.taxNo}
                onChange={handleInputChange}
                placeholder="Vergi No"
                required
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <input
                type="text"
                name="authorizedPerson1"
                value={formData.authorizedPerson1}
                onChange={handleInputChange}
                placeholder="Yetkili Kişi 1"
                required
              />
            </div>
            <div className="form-group">
              <input
                type="tel"
                name="phoneNumber1"
                value={formData.phoneNumber1}
                onChange={handleInputChange}
                placeholder="Telefon No 1"
                required
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <input
                type="text"
                name="authorizedPerson2"
                value={formData.authorizedPerson2}
                onChange={handleInputChange}
                placeholder="Yetkili Kişi 2"
              />
            </div>
            <div className="form-group">
              <input
                type="tel"
                name="phoneNumber2"
                value={formData.phoneNumber2}
                onChange={handleInputChange}
                placeholder="Telefon No 2"
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <input
                type="text"
                name="bankReceiver1"
                value={formData.bankReceiver1}
                onChange={handleInputChange}
                placeholder="Banka Alıcı Adı 1"
              />
            </div>
            <div className="form-group">
              <input
                type="text"
                name="bankName1"
                value={formData.bankName1}
                onChange={handleInputChange}
                placeholder="Banka Adı 1"
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <input
                type="text"
                name="iban1"
                value={formData.iban1}
                onChange={handleInputChange}
                placeholder="IBAN 1"
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <input
                type="text"
                name="bankReceiver2"
                value={formData.bankReceiver2}
                onChange={handleInputChange}
                placeholder="Banka Alıcı Adı 2"
              />
            </div>
            <div className="form-group">
              <input
                type="text"
                name="bankName2"
                value={formData.bankName2}
                onChange={handleInputChange}
                placeholder="Banka Adı 2"
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <input
                type="text"
                name="iban2"
                value={formData.iban2}
                onChange={handleInputChange}
                placeholder="IBAN 2"
              />
            </div>
          </div>

          <div className="submit-area">
            <button type="submit" disabled={isSubmitting}>
              {isSubmitting ? 'Ekleniyor...' : 'Kaydet'}
            </button>
            {errorMessage && <p className="error-message inline-feedback">{errorMessage}</p>}
            {successMessage && <p className="success-message inline-feedback">{successMessage}</p>}
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddCompany;
